import { render } from "./PrincipleBadge.vue?vue&type=template&id=21a9cab6&scoped=true"
import script from "./PrincipleBadge.vue?vue&type=script&lang=js"
export * from "./PrincipleBadge.vue?vue&type=script&lang=js"

import "./PrincipleBadge.vue?vue&type=style&index=0&id=21a9cab6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a9cab6"]])

export default __exports__